import { Alert, FormControl } from "@mui/material";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

import { default as React } from "react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      marginLeft: 0,
      marginRight: 0,
      width: "100%",
    },
  })
);

export function CommandNoParams(props) {
  const classes = useStyles();

  return (
    <>
      <FormControl className={classes.formControl}>
        <Alert severity="info">Команда не предусматривает параметров</Alert>
      </FormControl>
    </>
  );
}
